import { useContext } from 'react';
import { ViewportContext } from '../../contexts/viewport';

/**
 * @type {import('.').UseMediaQueryType}
 */
const useMediaQuery = () => {
  return useContext(ViewportContext);
};

export default useMediaQuery;
